import cn from 'classnames';
import React from 'react';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Icon from 'tbk-components/src/components/Icon';
import type { ILink } from 'tbk-components/src/components/Button';

export interface IIconLink extends ILink {
	icon?: string;
}

export interface IIconLinkGroup  {
	icon?: string;
	url?: ILink;
}
export interface ILinkGroupProps extends IBaseElementProps {
	links: IIconLinkGroup[];
}

/**
 * Styled link group
 * @block
 */

const LinkGroup: React.FC<ILinkGroupProps> = ({
	links = [],
	className,
	classNames = [],
}) => (
	<div className={className || cn('link-group', ...classNames)}>
		{links.map(({ url:{href, target, label}, icon }, index) => (
			<a
				key={index}
				className="link-group__link"
				href={href}
				target={target}
			>
				{icon && <Icon name={icon} />}
				{label && <h4>{label}</h4>}
			</a>
		))}
	</div>
);

export default LinkGroup;
